import React from 'react'
import { Form, Formik } from 'formik'
import Button from '../../../components/common/Button'
import Input from '../../../components/common/Input'
import { required } from '../../../utils/validators'

export default function TotalExpenseCategoryForm({ onCancel, onSubmit, initialValues, loading }) {
    return (
        <Formik onSubmit={onSubmit} initialValues={{ name: '', status: 'expenses', ...initialValues }}>
            <Form>
                <Input name="name" label="Категория" validate={required} />
                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                    </div>
                    <div className="button-wrapper">
                        <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </div>
            </Form>
        </Formik>
    )
}
